module.exports = __webpack_public_path__ + "static/img/lang.d39a7f74.png";